import { render } from "./button-component.vue?vue&type=template&id=2ff6d102&scoped=true"
import script from "./button-component.vue?vue&type=script&lang=js"
export * from "./button-component.vue?vue&type=script&lang=js"

import "./button-component.vue?vue&type=style&index=0&id=2ff6d102&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff6d102"]])

export default __exports__